import React, { AllHTMLAttributes, useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { FaSceneDictEnum, IFaDataItem, UserInfoType } from "store/user";
import googleImg from "@/assets/images/account/a-icon-3.svg";
// import emailImg from "@/assets/images/account/a-icon-1.svg";
import mobileImg from "@/assets/images/account/a-icon-2.svg";
import Link from "next/link";
import { waitRes } from "utils/axios";
import { getSecurityLevel } from "api/uaapi/user";
import C2CModal from "components/App/C2CModal";
import { useRouter } from "next/router";
import ModelAlert from "components/Antd/Modal/Alert";
import { Modal as AppPasskeyModal } from "@xt/Passkey";
import { Modal } from "antd";
import { get_getFa, put_getFa, delete_getFa } from "api/uaapi/user";
import SafeVerify from "components/App/SafeVerify/index";
import { axiosThrottle } from "utils/method";
import Passkey from "./passkey";
interface AccountSetProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
  userInfo?: UserInfoType;
}
const { useTranslation } = Hooks;
const AccountSet: React.FC<AccountSetProps> = ({ className, userInfo }) => {
  const t = useTranslation();
  const router = useRouter();
  const { updateState, isSubAcc, getUserInfo } = store.user;
  const [visible, setVisible] = useState(false);
  const [pushName, setPushName] = useState("");
  const [type, setType] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [visibleSafe, setVisibleSafe] = useState(false);
  const [faDatas, setFaDatas] = useState<IFaDataItem[]>([]);
  const [faBizType, setFaBizType] = useState(127);
  const [codeType, setCodeType] = useState("USER_2033");
  useEffect(() => {
    getFaDatas();
    getUserInfoData();
  }, []);

  const getUserInfoData = async () => await getUserInfo();

  const getFaDatas = async () => {
    const { data, err } = await waitRes(get_getFa, {});
    if (err) return;
    updateState({ faData: data });
    setFaDatas(data || []);
  };

  const authLen = useMemo(() => {
    return faDatas.filter((item: IFaDataItem) => !!item.enable).length;
  }, [faDatas]);

  // useMemo
  const handleRenderLevel = useMemo(() => {
    if (isSubAcc) {
      if (authLen == 1) {
        return "level3";
      }
      return "level1";
    } else {
      if (authLen == 1) {
        return "level1";
      } else if (authLen == 2) {
        return "level2";
      } else if (authLen == 3) {
        return "level3";
      }
      return "";
    }
  }, [authLen]);

  // method
  const changePushName = (pushName: string) => {
    setPushName(pushName);
    setVisible(true);
  };
  const changeVerify = () => {
    router.push({ pathname: pushName });
  };

  const getAuthData = (type: string) => {
    return faDatas.find((item: IFaDataItem) => item.type === type)?.enable || 0;
  };
  const getAuthOpen = (type: string) => {
    const item = faDatas.find((item: IFaDataItem) => item.type === type);
    return !!item?.bind && !item.enable;
  };
  const getIsBind = (type: string) => {
    const item = faDatas.find((item: IFaDataItem) => item.type === type);
    return !!item?.bind;
  };

  const openType = (type: string) => {
    setType(type);
    setVisibleSafe(true);
    setIsOpen(true);
    setCodeType("USER_2034");
    setFaBizType(127);
  };

  const getVerify = (type: string) => {
    setType(type);
    setIsOpen(false);
    setFaBizType(128);
    setCodeType("USER_2033");
    if (authLen < 3) {
      const gaAuth = getAuthData("GA");
      const mobileAuth = getAuthData("MOBILE");
      const emailAuth = getAuthData("EMAIL");
      let bindItem = {} as IFaDataItem;
      let info = "";
      let url = "";
      if (gaAuth && mobileAuth) {
        info = t("account.authEmailTips");
        bindItem = faDatas.find((item) => item.type === "EMAIL")!;
        url = "/accounts/user/email";
        setType("EMAIL");
      } else if (gaAuth && emailAuth) {
        info = t("account.authMobileTips");
        bindItem = faDatas.find((item) => item.type == "MOBILE")!;
        url = "/accounts/user/mobile";
        setType("MOBILE");
      } else if (mobileAuth && emailAuth) {
        bindItem = faDatas.find((item) => item.type === "GA")!;
        info = t("account.authGaTips");
        url = "/accounts/user/google-authenticator";
        setType("GA");
      }
      ModelAlert.confirm({
        center: true,
        content: info,
        okText: t("account.goEnable"),
        cancelText: t("account.cancel"),
        onOk: () => {
          if (!bindItem.bind) {
            router.push(url);
          } else {
            setFaBizType(127);
            setCodeType("USER_2034");
            setIsOpen(true);
            setVisibleSafe(true);
          }
        },
      });
    } else {
      setVisibleSafe(true);
    }
  };

  const submitForm = axiosThrottle(async (unlock, { faResultId }) => {
    const method = isOpen ? put_getFa : delete_getFa;
    const { err } = await waitRes(method, {
      errorPop: true,
      successPop: true,
      data: {
        faResultId,
        type,
      },
    });
    unlock();
    if (err) return;
    setVisibleSafe(false);
    getFaDatas();
  });

  console.log(userInfo, "userInfo");

  return (
    <div className={cx(styles.accountSet, styles["account_container"], className)}>
      <div className={cx(styles["accountSet-safety-level"])}>
        <div>{t("newAccount.authLevel")}</div>
        <div className={cx(styles["level-list"])}>
          <span>{t("google.level")}</span>
          <ul className={styles[handleRenderLevel]}>
            <li></li>
            <li></li>
            <li></li>
          </ul>
          {isSubAcc ? (
            <span>{authLen == 1 ? t("account.safeHigh") : t("account.safeLow")} </span>
          ) : (
            <span> {authLen == 3 ? t("account.safeHigh") : authLen == 2 ? t("account.safeMiddle") : t("account.safeLow")}</span>
          )}
        </div>
      </div>
      {/* 谷歌验证器 */}
      <div className={cx(styles["account_common_list"], styles["account_list_common"])}>
        <div className={styles["account_list_common_left"]}>
          {/* <div>
            <img src={googleImg} alt="" />
          </div> */}
          <div className={styles["account_sign"]}>
            <div className={styles["account_sign_header"]}>
              <span className={styles["account_sign_header_tit"]}>{t("account.GoogleAuthenticator") + `（${t("account.recommend")}）`}</span>

              {!!getAuthData("GA") && <span className={styles.account_enabled}>{t("account.enabled")}</span>}
            </div>
            <div className={styles["account_sign_footer"]}>
              <span className={styles["account_sign_header_desc"]}>{t("account.UsedForSecurityVerifications")}</span>
            </div>
          </div>
        </div>
        <div className={styles["account_list_common_right"]}>
          <span className={styles["account_sign_header_tip_mb"]}>
            <span className={cx(userInfo?.googleAuth == 0 ? styles["noBinding"] : styles["binding"])}>
              {userInfo?.googleAuth == 0 ? t("account.noBinding") : ``}
            </span>
          </span>
          <span className={styles["account_sign_header_tip_pc"]}>
            <span className={cx(userInfo?.googleAuth == 0 ? styles["noBinding"] : styles["binding"])}>
              {userInfo?.googleAuth == 0 ? t("account.noBinding") : ``}
            </span>
          </span>

          {userInfo?.googleAuth == 0 && (
            <Link href={"/accounts/user/google-authenticator"}>
              <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_binding"])}>{t("account.binding")}</span>
            </Link>
          )}

          {!!getAuthData("GA") && authLen > 1 && getIsBind("GA") && (
            <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_update"])} onClick={() => getVerify("GA")}>
              {t("account.closeVerify")}
            </span>
          )}

          {getAuthOpen("GA") && (
            <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_binding"])} onClick={() => openType("GA")}>
              {t("cmpt.toOpen")}
            </span>
          )}

          {userInfo?.googleAuth == 1 && (
            <span
              onClick={() => changePushName("/accounts/user/google-authenticator")}
              className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_update"])}
            >
              {t("account.change")}
            </span>
          )}
        </div>
      </div>

      {/* 邮箱 */}
      {
        /* eslint-disable */
        !(userInfo?.userAccountLevel! > 1) && (
          <div className={cx(styles["account_common_list"], styles["account_list_common"])}>
            <div className={styles["account_list_common_left"]}>
              {/* <div>
                <img src={emailImg} alt="" />
              </div> */}
              <div className={styles["account_sign"]}>
                <div className={styles["account_sign_header"]}>
                  <span className={styles["account_sign_header_tit"]}>{t("account.email")}</span>

                  {!!getAuthData("EMAIL") && <span className={styles.account_enabled}>{t("account.enabled")}</span>}
                  
                </div>
                <div className={styles["account_sign_footer"]}>
                  <span className={styles["account_sign_header_desc"]}>{t("account.UsedForSecurityVerifications")}</span>
                </div>
              </div>
            </div>
            <div className={styles["account_list_common_right"]}>
              <span className={styles["account_sign_header_tip_pc"]}>
                <span className={cx(!userInfo?.email ? styles["noBinding"] : styles["binding"])}>
                  {!userInfo?.email ? t("account.noBinding") : userInfo?.email?.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3")}
                </span>
              </span>
              <span className={styles["account_sign_header_tip_mb"]}>
                <span className={cx(!userInfo?.email ? styles["noBinding"] : styles["binding"])}>
                  {!userInfo?.email ? t("account.noBinding") : userInfo?.email?.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3")}
                </span>
              </span>
              {!userInfo?.email && (
                <Link href={"/accounts/user/email"}>
                  <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_binding"])}>{t("account.binding")}</span>
                </Link>
              )}
              {userInfo?.email && (userInfo?.userAccountLevel === 2 || authLen >= 2) && (
                <span
                  onClick={() => changePushName("/accounts/user/email")}
                  className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_update"])}
                >
                  {t("account.change")}
                </span>
              )}
            </div>
          </div>
        )
      }

      {/* 手机 */}
      {
        /* eslint-disable */
        !(userInfo?.userAccountLevel! > 1) && (
          <div className={cx(styles["account_common_list"], styles["account_list_common"])}>
            <div className={styles["account_list_common_left"]}>
              {/* <div>
                <img src={mobileImg} alt="" />
              </div> */}
              <div className={styles["account_sign"]}>
                <div className={styles["account_sign_header"]}>
                  <span className={styles["account_sign_header_tit"]}>{t("account.phone")}</span>

                  {!!getAuthData("MOBILE") && <span className={styles.account_enabled}>{t("account.enabled")}</span>}
                </div>
                <div className={styles["account_sign_footer"]}>
                  <span className={styles["account_sign_header_desc"]}>{t("account.UsedForSecurityVerifications")}</span>
                </div>
              </div>
            </div>

            <div>
                <span className={styles["account_sign_header_tip_mb"]}>
                  <span className={cx(!userInfo?.mobile ? styles["noBinding"] : styles["binding"])}>
                    {!userInfo?.mobile
                      ? t("account.noBinding")
                      : `+${userInfo?.countryCode} ${
                          (userInfo?.mobile + "").length > 7
                            ? userInfo?.mobile?.replace(/(\d{3})\d*(\d{4})/, "$1***$2")
                            : userInfo?.mobile?.replace(/(\d{2})\d*(\d{2})/, "$1***$2")
                        }`}
                  </span>
                </span>
              </div>

            <div className={styles["account_list_common_right"]}>
              <span className={styles["account_sign_header_tip_pc"]}>
                <span className={cx(!userInfo?.mobile ? styles["noBinding"] : styles["binding"])}>
                  {!userInfo?.mobile
                    ? t("account.noBinding")
                    : `+${userInfo?.countryCode} ${
                        (userInfo?.mobile + "").length > 7
                          ? userInfo?.mobile?.replace(/(\d{3})\d*(\d{4})/, "$1***$2")
                          : userInfo?.mobile?.replace(/(\d{2})\d*(\d{2})/, "$1***$2")
                      }`}
                </span>
              </span>              {!userInfo?.mobile && (
                <Link href={"/accounts/user/mobile"}>
                  <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_binding"])}>{t("account.binding")}</span>
                </Link>
              )}

              {!!getAuthData("MOBILE") && authLen > 1 && getIsBind("MOBILE") && (
                <span
                  className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_update"])}
                  onClick={() => getVerify("MOBILE")}
                >
                  {t("account.closeVerify")}
                </span>
              )}

              {getAuthOpen("MOBILE") && (
                <span
                  className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_binding"])}
                  onClick={() => openType("MOBILE")}
                >
                  {t("cmpt.toOpen")}
                </span>
              )}

              {userInfo?.mobile && (userInfo?.userAccountLevel === 2 || authLen >= 2) && (
                <span
                  onClick={() => changePushName("/accounts/user/mobile")}
                  className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_update"])}
                >
                  {t("account.change")}
                </span>
              )}
            </div>
          </div>
        )
      }

      {/* 通行密钥 */}
      {/* {!isSubAcc && <Passkey />} */}

      {/* 安全验证 */}
      <AppPasskeyModal
        faBizType={faBizType}
        dynamicCodeType={codeType}
        successCallback={submitForm}
        open={visibleSafe}
        onClose={() => setVisibleSafe(false)}
        isDark={store.app.isDark}
        userInfo={store.user.userInfo}
      />
      {/*<Modal*/}
      {/*  className={cx(styles["common_modal"], styles["setting_modal"])}*/}
      {/*  open={visibleSafe}*/}
      {/*  title={t('newAccount.safeCodeTips')}*/}
      {/*  width={500}*/}
      {/*  footer={null}*/}
      {/*  onCancel={() => setVisibleSafe(false)}*/}
      {/*>*/}
      {/*  <SafeVerify*/}
      {/*    faBizType={faBizType}*/}
      {/*    dynamicCodeType={codeType}*/}
      {/*    handleSuccessFn={submitForm}*/}
      {/*    mt={20} />*/}
      {/*</Modal>*/}
      <C2CModal visible={visible} changeVisible={() => setVisible(false)} changeVerify={changeVerify}></C2CModal>
    </div>
  );
};
export default observer(AccountSet);
